import React from 'react';
import Particle from './../../Particle';
import {Paragraph, Image, Title} from './../../Basics';

const Particle01_EN = () => (<div>

  <Title level={3}>
   The world’s first Cybathlon competition has revealed the opportunities available to disabled people when
   human being and machine become one.
  </Title>

  <Paragraph>
   Out of the corner of his eye Florian Hauser sees that his competitor is about to cross the finishing line,
   but he has no thoughts of quitting. He remains focused, positions his wheelchair at the very edge of the top step – and accelerates. 

  </Paragraph>

  <Image
    source={require('./01_FlorianHauser_Action.jpg')}
    title='Florian Hauser during the competition'
    caption='Florian Hauser competing in the wheelchair race during the first Cybathlon tournament.'
  />

  <Paragraph>
   Florian is one of 70 athletes from 25 countries having participated, last October, in a unique competition: the Cybathlon.
   During this event, physically disabled participants competed in various disciplines using robotic aids. They were cheered on
   by 4000 visitors in the Swiss Arena in Kloten and watched by tens of thousands of television viewers. “Having so many spectators
   rooting for you is an experience I wish everyone could enjoy at least once”, says Florian.
  </Paragraph>

  <Particle
    number={3}
  />

  <Image
    source={require('./01_Impression.jpg')}
    title='Cybathlon impressions'
    caption='During the world’s first Cybathlon in Zurich, thousands of spectators supported the athletes.'
  />

  <Paragraph>
    Florian, a paraplegic athlete, participated in the motorised wheelchair race for the Hochschule Rapperswil HSR
    Enhanced team. Specifically for this competition, the engineers built a wheelchair which, among other things,
    can climb stairs - one of the most challenging obstacles in the race that Florian trained for for many months.
    In all other disciplines, participants and technologies also faced difficult tasks.
  </Paragraph>

  <Particle
    number={2}
  />

  <Particle
    number={5}
  />

 <Title level={3}>
   Maximum performance in everyday tasks
 </Title>


 <Paragraph>
   The Cybathlon’s aim was the accomplishment of seemingly simple tasks rather than top athletic performances: rising
   from an armchair, buttoning a jacket, opening a tin. These activities can be quite daunting for individuals who are
   unable to move their legs or who are missing an arm, even when modern aids and prostheses are available. “Through the
   Cybathlon, we hope to encourage the development of new technologies”, says Robert Riener, a professor at the ETH Zurich
   and the initiator of this event.
  </Paragraph>

  <Particle
    number={11}
  />

  <Title level={3}>
   Narrow victory
  </Title>

  <Paragraph>
    When Florian comes jolting down the stairs in his wheelchair and crosses the finishing line, the cameras are not trained
    on him, yet he has won the competition slightly ahead of his rival from Hong Kong! He lifts his arms and cheers.
    Will he take part in the next Cybathlon, planned to take place in two years? “By all means, if my team is willing to have me again.”
  </Paragraph>

  <Particle
    number={23}
  />


</div>);

export default Particle01_EN;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle01/Particle01_EN.js
 **/